import { useIsQuote } from "../../../quote/QuoteContainer";
import { api } from "../../../../../api/API";
export function useMiscProductApi() { const isQuote = useIsQuote(); if (isQuote)
    return api.quoteMiscProducts; return api.miscProducts; }
